import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { environment } from 'src/environments/environment';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthenticationService } from './services/authentication.service';
import { NavigationService } from './services/navigation.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from './services/user.service';
import swal from 'sweetalert2';
import { UserSessionService } from './services/usersession.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  title = 'UMIS';
  public validinput: RegExp = /^[^\s]+(\s+[^\s]+)*$/;
  isLoggedOutMessage: boolean = false;
  islogin: any;
  instituteId: number;
  constructor(
    dateTimeAdapter: DateTimeAdapter<any>,
    private authService: AuthenticationService,
    private navigation: NavigationService,
    private idle: Idle, private keepalive: Keepalive,
    private toaster: ToastrService,
    private userSessionService: UserSessionService,
    private userService: UserService,
    private router: Router,) {
    dateTimeAdapter.setLocale('en-in');
    

  }

  @HostListener('document:input', ['$event'])
  handleInput(event: InputEvent): void {
    debugger
    if (event.target instanceof HTMLInputElement) {
      const inputElement = event.target as HTMLInputElement;
      const inputValue = inputElement.value;
      // Replace < and > with empty string
      inputElement.value = inputValue.replace(/[<>]/g, '');
      // Emit an input event to update ngModel or form controls
      inputElement.dispatchEvent(new Event('input'));
    } 
  }

  // @HostListener('mouseenter', ['$event'])
  // onMouseEnter(event: MouseEvent) {
  //   // Handle the mouseenter event
  //   if (JSON.parse(localStorage.getItem('isLoggedin')) !== true) {
  //     if (this.isLoggedOutMessage) {
  //       this.toaster.warning("Your session has timed out. Please log in again to continue.");
  //       this.isLoggedOutMessage = false;
  //     }
  //   }
  // }

  // @HostListener('mouseleave', ['$event'])
  // onMouseLeave(event: MouseEvent) {
  //   // Handle the mouseleave event (similar to mouseout)
  //   if (JSON.parse(localStorage.getItem('isLoggedin')) !== true) {
  //     if (this.isLoggedOutMessage) {
  //       this.toaster.warning("Your session has timed out. Please log in again to continue.");
  //       this.isLoggedOutMessage = false;
  //     }
  //   }
  // }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  ngOnInit(): void {
    // this.startIdle();
  //   this.idle.setIdle(1);
  //   // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
  //   this.idle.setTimeout(2);
  //   // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
  //   this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

  //   this.idle.onIdleStart.subscribe(() => {
  //     console.log("User is idle");
  //   });


  //   this.idle.onIdleEnd.subscribe(() => {
  //     this.idleState = 'No longer idle.'
  //     console.log(this.idleState);
  //     // this.reset();
  //   });

  // this.idle.onTimeout.subscribe(() => {
  //   console.log("Session timed out");

  //   this.idle.stop(); // ✅ VERY IMPORTANT

  //   this.userService.logout(true).subscribe(() => {
  //     this.authService.logOut();
  //     this.navigation.goToLogin();
  //     this.toaster.warning(
  //       "Your session has timed out. Please log in again to continue."
  //     );
  //   });
  // });

  //   this.idle.watch();

  //   // this.idle.onIdleStart.subscribe(() => {
  //   //   this.idleState = 'You\'ve gone idle!'
  //   //   console.log(this.idleState);
  //   //   //this.childModal.show();
  //   // });

  //   this.idle.onTimeoutWarning.subscribe((countdown) => {
  //     this.idleState = 'You will time out in ' + countdown + ' seconds!'
  //     console.log(this.idleState);
  //   });

  //   // sets the ping interval to 15 seconds
  //   this.keepalive.interval(15);
  //   this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

  //   this.reset();

    this.instituteId = parseInt(this.userSessionService.getInstituteId());
    // console.log(this.detectBrowserName());
    //   console.log(this.detectBrowserVersion());
    if (this.instituteId) {
      swal.fire({
        title: 'Information',
        html: `
       <ul class="text-justify p-0" style="font-size: 14px;">
         <li>
         <span style="color: red; font-weight: bold;">Kind Attention</span>: College Nodal Officers – Attendance Verification Module for Pudhumai Penn & Tamil Pudhalvan Schemes <br>(Q4: Oct - Dec 2025) is now OPEN. Last Date for Submission: 31.12.2025. Kindly update & verify attendance on time
  </li>
  <li class="my-2">
    For any queries, please raise a ticket under the 
    <span style="color: black; font-weight: bold;">“Grievance Redressal”</span> 
    menu with valid proof.
  </li>
  <li class="my-2">
    For further assistance, call our Toll‑free number 
    <span style="color: black; font-weight: bold;">14417</span> 
    (Select Option 9) for institute/student‑related queries.
  </li>
  <li class="my-2">
    For technical issues, contact us via Call/WhatsApp at 
    <span style="color: black; font-weight: bold;">9344237663 / 9344252673</span>.
  </li>
  <li class="my-2">
    It has been decided that for the students who have completed their schooling inside Tamil Nadu, Student EMIS ID will be maintained
  </li>
  <li>
    And for students who have done their schooling outside Tamil Nadu, a 9 series Student EMIS ID will be generated UMIS portal
  </li>
</ul>


        `,
        icon: "info",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok',
        allowOutsideClick: false,
      })
    }

    if (environment.production) {
      if (location.protocol !== 'https:') {
        location.replace(`https:${location.href.substring(location.protocol.length)}`);
      }

    }

    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url === '/monthlyreport'
          || e.url.startsWith('/users/')
          || e.url.startsWith('/dashboard')
        ) {
          document.body.classList.add('removeglobalfilter');
        } else {
          document.body.classList.remove('removeglobalfilter');
        }
      }
    });
  }

  startIdle() {

  // 🔥 FULL RESET (CRITICAL)
  this.idle.stop();
  this.idle.clearInterrupts();
  this.idle.ngOnDestroy();

  // ⏱ 3-second total timeout
  this.idle.setIdle(1);
  this.idle.setTimeout(2);
  this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

  this.idle.onIdleStart.subscribe(() => {
    console.log('User is idle');
  });

  this.idle.onIdleEnd.subscribe(() => {
    console.log('User active again');
  });

  this.idle.onTimeout.subscribe(() => {
    console.log('Session timed out');
    this.handleTimeout();
  });

  this.idle.onTimeoutWarning.subscribe((countdown) => {
    console.log(`Logout in ${countdown}s`);
  });

  // ✅ WATCH ONCE
  this.idle.watch();
}

handleTimeout() {

  // 🔐 STOP EVERYTHING
  this.idle.stop();
  this.idle.clearInterrupts();
  this.idle.ngOnDestroy();

  this.userService.logout(true).subscribe(() => {
    this.authService.logOut();
    this.navigation.goToLogin();
    this.toaster.warning(
      'Your session has timed out. Please log in again.'
    );
  });
}


  clearAllData() {
  }

  detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }


  detectBrowserVersion() {
    var userAgent = navigator.userAgent, tem,

      matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    console.log(userAgent, '------------------');
    if (/trident/i.test(matchTest[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return 'IE ' + (tem[1] || '');
    }

    if (matchTest[1] === 'Chrome') {
      tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }

    matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);
    return matchTest.join(' ');
  }

}